import { useCartRecapData } from '@/hooks/useCartRecapData.ts'

import { RecapDetails } from '../RecapDetails'

interface ReservationRecapDetailsProps {
  className?: string
  useCartInfoData?: boolean
  isOpen?: boolean
}

export const ReservationRecapDetails = (
  props: ReservationRecapDetailsProps
) => {
  const { useCartInfoData, isOpen, ...restProps } = props

  const {
    deposit,
    costs,
    total,
    location,
    reservations,
    beachName,
    endDate,
    startDate,
    region,
    bookingPeriod,
  } = useCartRecapData(useCartInfoData)

  const summaryProps = {
    beachName,
    bookingPeriod,
    endDate,
    location,
    region,
    startDate,
    total,
  }

  return (
    <RecapDetails {...restProps} {...(!total && { as: 'div' })} isOpen={isOpen}>
      <RecapDetails.Summary {...summaryProps} />

      {!!total && (
        <>
          <RecapDetails.Reservations
            itemWrapperClassName="p-4"
            reservations={reservations}
            separatorClassName="my-0 border-gray-100"
          />

          <RecapDetails.Costs
            className="border-t border-t-gray-100 bg-gray-25 p-4"
            costs={costs}
            deposit={deposit}
            total={total}
          />
        </>
      )}
    </RecapDetails>
  )
}
